<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" >
    <div class="vx-col">
      <div class="w-full text-center" style="margin-bottom:64px;">
        <img v-if="hostname === 'ep.maot.co.kr'" src="@/assets/images/pages/ep-login.svg" alt="login" style="width:100%; max-width:450px; max-height: 160px;">
        <img v-else-if="hostname === 'dgjg.maot.co.kr'" src="@/assets/images/pages/dgjg-login.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else-if="hostname === 'gsnd.maot.co.kr'" src="@/assets/images/pages/login_gsnd.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else-if="hostname === 'bsgs.maot.co.kr'" src="@/assets/images/pages/login_bsgs.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else-if="hostname === 'gjng.maot.co.kr'" src="@/assets/images/pages/gjn-login.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else-if="hostname === 'gdco.maot.co.kr'" src="@/assets/images/pages/gdco-login.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else-if="hostname === 'publicdemo.maot.co.kr'" src="@/assets/images/pages/public-login.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else-if="hostname === 'kangwonlanddemo.maot.co.kr'" src="@/assets/images/pages/kangwonland-login.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else-if="hostname === 'companydemo.maot.co.kr'" src="@/assets/images/pages/login_companydemo.svg" alt="login" style="width:100%; max-width:450px;">
        <img v-else src="@/assets/images/pages/login_companydemo.svg" alt="login" style="width:100%; max-width:450px; max-height: 160px;">
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center grid grid-cols-7 md:grid-cols-12" style="max-width: 1150px;">
<!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block col-span-5" style="height:100%; width:100%;">
              <img src="@/assets/images/pages/login2.svg"
                   style="width: 100%; height: 100%; object-fit: cover;"
                   alt="login" class="mx-auto">
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-7" style="padding:40px 0px;">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">로그인</h4>
                  <p>아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="아이디 입력"
                    v-model="emailInput"
                    :danger="emailRules"
                    class="w-full"/>

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="비밀번호 입력"
                    v-model="passwordInput"
                    class="w-full mt-6"
                    @keyup.enter="login"/>

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
<!--                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha
                    v-if="recaptcha"
                    class="mb-8"

                    ref="recaptcha"
                    @expired="onExpired"
                    @render="cargarCaptchar = true"
                    @error="recaptchar = false"
                    @verify="onVerify"
                    sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU"/>

                  <vs-button class="float-right"  color="secondary" @click="login">로그인</vs-button>


                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import config from '/public/config'
import VueCookie from 'vue-cookie'
import constant from '@/constant/constant'
import VueRecaptcha from 'vue-recaptcha'

export default {
  components:{
    VueRecaptcha
  },
  watch: {
    checkbox_remember_me (checkbox_remember_me) {
      this.checkbox_remember_me = checkbox_remember_me
      VueCookie.set('login_remember_me', checkbox_remember_me, 30)

      if (!this.checkbox_remember_me) {
        VueCookie.set('login_remember_email', '')
      }
    }
  },
  data () {
    return {
      hostname: config.HOST_NAME,
      emailInput: '',
      passwordInput: '',
      checkbox_remember_me: false,
      recaptcha: false,
      recaptchaValue:'',
    }
  },
  computed: {
    emailRules () {
      return this.checkEmailRule(this.emailInput)
    }
  },
  created () {
    this.checkbox_remember_me = (VueCookie.get('login_remember_me') === 'true')
    if (this.checkbox_remember_me) {
      this.emailInput = (VueCookie.get('login_remember_email')) ? VueCookie.get('login_remember_email') : ''
    }
  },
  methods: {
    onVerify (r) {
      this.recaptchaValue = r
      this.recaptcha = true
    },
    onExpired () {
      this.$refs.recaptcha.reset()
    },

    handleChangeRememberMe (data) {
    },
    checkEmailRule (v) {
      if (v === '') {
        return true
      }

      const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
      return !regExp.test(v)
    },

    async login () {

      const email = this.emailInput
      const pw = this.passwordInput
      const rcv = this.recaptchaValue

      this.$store.dispatch('LOGIN', {
        email,
        pw,
        rcv
      }).then(() => {
        if (VueCookie.get('login_remember_me') === 'true') {
          VueCookie.set('login_remember_email', this.emailInput, 30)
        }

        localStorage.setItem('login_username', email)

        // 프로젝트 개수만큼 삭제해야함.
        // 지금은 임의로 10개 삭제하도록 설정
        for (let i = 0; i< 10; i++) {
          localStorage.removeItem(`${email}_${i + 1}_boardIds`)
        }
        sessionStorage.removeItem('/api/auth/me')
        sessionStorage.removeItem('/api/v1/member/all')
        localStorage.removeItem('sub_company')
        this.$router.replace('/home').then(value => {
          this.$router.go(0)
        })
      }).catch(err => {
        if (this.recaptcha) {
          this.$refs.recaptcha.reset()
        }
        switch (constant.getErrorCode(err)) {
        case constant.ERROR_LOGIN_ID_NULL: alert('아이디를 입력해주세요'); break
        case constant.ERROR_LOGIN_PASSWORD_NULL: alert('비밀번호를 입력해주세요'); break
        case constant.ERROR_LOGIN_INVALID_CREDENTIALS: alert('아이디 또는 패스워드가 틀립니다'); break
        case constant.ERROR_LOGIN_INVALID_RECAPTCHA:
          this.recaptcha = true
          break
        }
      })
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
